export default __webpack_public_path__ + "static/media/king-on-africa.6b019e23.jpg";